export default __webpack_public_path__ + "static/media/box2.cbbffced.png";